import { ca } from '@cian/analytics';
import { LinkButton } from '@cian/ui-kit/button';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectOfferId } from 'shared/selectors';

const trackOnlineBookingBookButtonClick = (cianId: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DailyrentButton',
    action: 'Click',
    label: 'ToCheckout',
    page: {
      pageType: 'Card',
    },
    products: [{ id: cianId }],
  });
};

export const OnlineBookingBookButtonContainer = () => {
  const offerId = useSelector(selectOfferId);
  const fakeCheckoutPage = 'https://www.cian.ru/';

  const onClick = React.useCallback(() => {
    trackOnlineBookingBookButtonClick(offerId);
  }, [offerId]);

  return (
    <LinkButton
      href={fakeCheckoutPage}
      onClick={onClick}
      theme="fill_primary"
      size="M"
      fullWidth
      target="_blank"
      rel="noopener noreferrer"
    >
      Забронировать
    </LinkButton>
  );
};
